import { ReceptionSummary } from "../list";

// 依頼受付検索結果model
export class ReceptionSearchResult {
  public list: ReceptionSummary[];
  public overLimitMessage: string;
}
